

/**
 * Uses a LRU cache to make a given parametrized function cached.
 * Caches just the last value.
 * The key must be JSON serializable.
*/
export class LRUCachedFunction<TArg, TComputed> {
	private a: TComputed | undefined = undefined;
	private b: string | undefined = undefined;

	constructor(private readonly c: (arg: TArg) => TComputed) {
	}

	public get(arg: TArg): TComputed {
		const key = JSON.stringify(arg);
		if (this.b !== key) {
			this.b = key;
			this.a = this.c(arg);
		}
		return this.a!;
	}
}

/**
 * Uses an unbounded cache (referential equality) to memoize the results of the given function.
*/
export class CachedFunction<TArg, TValue> {
	private readonly a = new Map<TArg, TValue>();
	public get cachedValues(): ReadonlyMap<TArg, TValue> {
		return this.a;
	}

	constructor(private readonly b: (arg: TArg) => TValue) { }

	public get(arg: TArg): TValue {
		if (this.a.has(arg)) {
			return this.a.get(arg)!;
		}
		const value = this.b(arg);
		this.a.set(arg, value);
		return value;
	}
}
